exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (min-width:350px){.outlet-logo{min-width:76px}.outlet-logo img{width:65px;height:65px}}.dlg-postcode-search input.text-input{text-transform:uppercase}.front-image{width:100%;height:50vh;object-fit:cover}.logo{height:100%;padding:10px;margin:0 auto;display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4f048a58","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/js/components/outlets/outlets.vue
// module id = haYn
// module chunks = 0